import React from 'react';
import { cn } from '@core/utils/cn';

interface PageTab {
    label: string;
    id: string;
}

interface PageTabsProps {
    tabs: PageTab[];
    value: number;
    onChange(index: number): void;
}

export const PageTabs = ({ tabs, value, onChange }: PageTabsProps) => (
    <nav className="flex flex-wrap gap-1" role="tablist">
        {tabs.map((tab, index) => (
            <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={value === index}
                onClick={() => onChange(index)}
                className={cn(
                    'rounded-full px-4 py-1.5 text-sm font-medium transition-colors',
                    value === index
                        ? 'bg-foreground text-background'
                        : 'text-muted-foreground hover:bg-accent hover:text-foreground'
                )}
            >
                {tab.label}
            </button>
        ))}
    </nav>
);
